import styles from "./Privacy.module.scss";

interface Props {
  /* Let's describe props here */
}

export const Privacy: React.FC<Props> = () => {
  return <div className={styles.root}>a Privacy component</div>;
};
